export default __webpack_public_path__ + "900ac4a7000e12cde4cd594a05ffca4c.png";